import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

/**
 * BreadcrumbAdapter - Compatibilidade com componente Breadcrumb do integrar-skin
 * Usa Ant Design v5 Breadcrumb
 *
 * @param {Array} data - Array de itens do breadcrumb
 * @example
 * <BreadcrumbAdapter
 *   data={[
 *     { titulo: "RELATÓRIOS", link: "" },
 *     { titulo: "ADICIONAIS", link: "/manager/relatorios-entidade/adicionais" }
 *   ]}
 * />
 */
const BreadcrumbAdapter = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <Breadcrumb style={{ marginBottom: 16 }}>
      {data.map((item, index) => (
        <Breadcrumb.Item key={index}>
          {item.link ? (
            <Link to={item.link}>{item.titulo}</Link>
          ) : (
            <span>{item.titulo}</span>
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default BreadcrumbAdapter;
